// Set relative time thresholds. These settings will be applied globally for every moment instance:
import moment from "moment"

moment.relativeTimeThreshold("ss", 3) // show "a few seconds" only if lees than 3 seconds
moment.relativeTimeThreshold("h", 25) // show "hours" when less than 24.51 hours
moment.relativeTimeThreshold("m", 61) // show "minutes" when less than 60.51 minutes
